import {
  TeacherClassSubjectQuery,
  TeacherClassSubjectQueryVariables,
  TeacherClassSubjectFragment,
  TeacherClassSubjectDocument,
  TeacherClassStudentsQuery,
  TeacherClassStudentsQueryVariables,
  TeacherClassStudentFragment,
  TeacherClassStudentsDocument,
  TeacherClassesQuery,
  TeacherClassesQueryVariables,
  TeacherClassFragment,
  TeacherClassesDocument,
} from "../types";
import { client } from "../../client";

// [Teacher] Get subjects by classes
export async function teacherGetClassSubjects(
  variables: TeacherClassSubjectQueryVariables
): Promise<Readonly<TeacherClassSubjectFragment[]>> {
  try {
    const result = await client.query<
      TeacherClassSubjectQuery,
      TeacherClassSubjectQueryVariables
    >({
      query: TeacherClassSubjectDocument,
      variables,
    });
    return result.data.subjects;
  } catch (error) {
    throw Error(error);
  }
}

// [Teacher] Get students by class
// Used on Grades Page, for now only for the 2nd step of the dropwdown.
export async function teacherGetClassStudents(
  variables: TeacherClassStudentsQueryVariables
): Promise<Array<{ user: Array<{ full_name?: string; id: string }> }>> {
  try {
    const result = await client.query<
      TeacherClassStudentsQuery,
      TeacherClassStudentsQueryVariables
    >({
      query: TeacherClassStudentsDocument,
      variables,
    });
    return result.data.student_class;
  } catch (error) {
    throw Error(error);
  }
}

// [Teacher] Get all classes
// Used on Grades Page, for now only for the 1st step of the dropwdown.
export async function teacherGetClasses(
  variables: TeacherClassesQueryVariables
): Promise<TeacherClassFragment[]> {
  try {
    const result = await client.query<
      TeacherClassesQuery,
      TeacherClassesQueryVariables
    >({
      query: TeacherClassesDocument,
      variables,
    });
    return result.data.classes;
  } catch (error) {
    throw Error(error);
  }
}
